// ADR 0022 D3: Pauling electronegativities, for which end of an ionic bond is the cation. Only the
// elements an ionic bond is commonly drawn between; an element missing here is left to the
// direction the bond was drawn in (from the cation).
const PAULING: Readonly<Record<number, number>> = {
  1: 2.2,
  3: 0.98,
  4: 1.57,
  5: 2.04,
  6: 2.55,
  7: 3.04,
  8: 3.44,
  9: 3.98,
  11: 0.93,
  12: 1.31,
  13: 1.61,
  14: 1.9,
  15: 2.19,
  16: 2.58,
  17: 3.16,
  19: 0.82,
  20: 1.0,
  21: 1.36,
  22: 1.54,
  23: 1.63,
  24: 1.66,
  25: 1.55,
  26: 1.83,
  27: 1.88,
  28: 1.91,
  29: 1.9,
  30: 1.65,
  31: 1.81,
  32: 2.01,
  33: 2.18,
  34: 2.55,
  35: 2.96,
  37: 0.82,
  38: 0.95,
  39: 1.22,
  40: 1.33,
  47: 1.93,
  48: 1.69,
  49: 1.78,
  50: 1.96,
  51: 2.05,
  52: 2.1,
  53: 2.66,
  55: 0.79,
  56: 0.89,
  57: 1.1,
  78: 2.28,
  79: 2.54,
  80: 2.0,
  81: 1.62,
  82: 2.33,
  83: 2.02,
  87: 0.7,
  88: 0.9
};

/** The classic Pauling threshold: a bond this polar or more is mostly ionic (Na–O 2.51, Na–Cl 2.23). */
export const IONIC_ELECTRONEGATIVITY_DIFFERENCE = 1.7;

export function paulingElectronegativity(atomicNumber: number): number | undefined {
  return PAULING[atomicNumber];
}
